
import React, { useState } from 'react';
import { ProfileHeaderMobile } from './ProfileHeaderMobile';
import { ProfileHeaderDesktop } from './ProfileHeaderDesktop';
import UserProfileSidebar from './UserProfileSidebar';
import { supabase } from "@/integrations/supabase/client";

type SocialMediaPlatform = "instagram" | "twitter" | "facebook" | "youtube" | "website";
interface SocialMediaLink {
  platform: SocialMediaPlatform;
  url: string;
}

interface ProfileHeaderProps {
  profile: {
    id: string;
    username?: string;
    avatar_url?: string;
    banner_url?: string;
    bio?: string;
    website?: string;
    location?: string;
    social_links?: SocialMediaLink[];
    primary_skill?: string;
  };
  currentUser: string | null;
  isFollowing: boolean;
  followersCount: number;
  followingCount: number;
  isMobile: boolean;
  onProfileUpdate: () => void;
  onFollowToggle: () => void;
  onLogout: () => void;
  sidebarCollapsed?: boolean;
  setSidebarCollapsed?: (collapsed: boolean) => void;
  handleBannerFileChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handleAvatarFileChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  bannerFileRef: React.RefObject<HTMLInputElement>;
  avatarFileRef: React.RefObject<HTMLInputElement>;
  isOwnProfile: boolean;
}

export function ProfileHeader({
  profile,
  currentUser,
  isFollowing,
  followersCount,
  followingCount,
  isMobile,
  onProfileUpdate,
  onFollowToggle,
  onLogout,
  sidebarCollapsed = false,  // Valor padrão
  setSidebarCollapsed = () => {},  // Função vazia como padrão
  handleBannerFileChange,
  handleAvatarFileChange,
  bannerFileRef,
  avatarFileRef,
  isOwnProfile
}: ProfileHeaderProps) {
  const [bannerVisible, setBannerVisible] = useState(true);
  
  return (
    <>
      <UserProfileSidebar 
        profile={profile} 
        isCollapsed={sidebarCollapsed} 
        setIsCollapsed={setSidebarCollapsed} 
        isOwnProfile={isOwnProfile}
      />
      
      <div 
        className={`transition-all duration-300 ${!sidebarCollapsed ? 'md:ml-[280px]' : ''}`}
      >
        {isMobile ? (
          <ProfileHeaderMobile
            profile={profile}
            currentUser={currentUser}
            isFollowing={isFollowing}
            followersCount={followersCount}
            followingCount={followingCount}
            onProfileUpdate={onProfileUpdate}
            onFollowToggle={onFollowToggle}
            onLogout={onLogout}
            handleBannerFileChange={handleBannerFileChange}
            handleAvatarFileChange={handleAvatarFileChange}
            bannerFileRef={bannerFileRef}
            avatarFileRef={avatarFileRef}
            isOwnProfile={isOwnProfile}
          />
        ) : (
          <ProfileHeaderDesktop
            profile={profile}
            currentUser={currentUser}
            isFollowing={isFollowing}
            followersCount={followersCount}
            followingCount={followingCount}
            onProfileUpdate={onProfileUpdate}
            onFollowToggle={onFollowToggle}
            onLogout={onLogout}
            handleBannerFileChange={handleBannerFileChange}
            handleAvatarFileChange={handleAvatarFileChange}
            bannerFileRef={bannerFileRef}
            avatarFileRef={avatarFileRef}
            isOwnProfile={isOwnProfile}
            bannerVisible={bannerVisible}
            setBannerVisible={setBannerVisible}
          />
        )}
      </div>
    </>
  );
}
